import { SET_SEARCH_HOME, CLEAR_SEARCH_HOME } from "../actions/actionsTypes";

const initialState = {
  content: [],
};

export const searchReducer = (state = initialState, action) => {
  if (action.type === SET_SEARCH_HOME) {
    return { ...state, content: action.payload };
  }
  if (action.type === CLEAR_SEARCH_HOME) {
    return { ...state, content: [] };
  }
  return state;
};
